import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import bgLight from "../assets/bg001.png";
import bgDark from "../assets/bg002.png";
import useSystemDarkMode from "../utils/useDarkMode";

const PublicLayout = () => {
    const { darkMode } = useSystemDarkMode();

    useEffect(() => {
        document.body.classList.add("public-layout");
        return () => {
            document.body.classList.remove("public-layout");
        };
    }, [darkMode]);

    return (
        <div
            className={`${darkMode ? "dark" : ""} min-h-screen flex bg-gray-100 dark:bg-gray-900 font-sans transition`}
            style={{
                backgroundImage: `url(${darkMode ? bgDark : bgLight})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
            }}
        >
            <img src={bgDark} className={"w-1 h-1 opacity-0"} alt="" />
            <img src={bgLight} className={"w-1 h-1 opacity-0"} alt="" />
            <div className="flex flex-1 flex-col p-3 transition sm:p-4 lg:p-10">
                <main className="flex flex-grow items-stretch justify-center px-0 lg:items-center lg:px-4">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default PublicLayout;
